export default __webpack_public_path__ + "static/media/ggface.ef5e67cd.svg";